(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CambiarFechasDialogController', CambiarFechasDialogController);

    CambiarFechasDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'SSAsignacion', 'AlertService'];

    function CambiarFechasDialogController ($timeout, $scope, $uibModalInstance, entity, SSAsignacion, AlertService) {
        var vm = this;

        entity.$promise.then(function(result) {
        	vm.sSAsignacionDTO = result;
        	vm.motivo = '';
        	        	
			vm.iniPrestacionOptions = {
			    enableTime: false,
			  };

			vm.finPrestacionOptions = {
			    enableTime: false,
			  };  

			vm.fechaLiberacionOptions = {
			    enableTime: false,
			  };  

		});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

		$scope.format = 'yyyy/MM/dd';
        
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;        

        vm.clear = clear;
        vm.save = save;
        vm.validateDates = validateDates;
        
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {
        	SSAsignacion.cambiarFechasAdmin({
				'asignacion': vm.sSAsignacionDTO,
				'motivo': vm.motivo,
			}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAsignacionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        	
        function onSaveError () {
            vm.isSaving = false;
        }
        
        vm.datePickerOpenStatus.iniPrestacion = false;
        vm.datePickerOpenStatus.finPrestacion = false;
        vm.datePickerOpenStatus.fechaLiberacion = false;
        
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function validateDates(){
        	var startDate = vm.sSAsignacionDTO.iniPrestacion;
        	var endDate = vm.sSAsignacionDTO.finPrestacion;
        	var minEndDate = angular.copy(startDate);
        	if(startDate != null && endDate != null){
	        	minEndDate.setMonth(startDate.getMonth() + 6);
	        	$scope.editForm.finPrestacion.$setValidity("endBeforeStart", endDate > startDate);
	        	$scope.editForm.finPrestacion.$setValidity("end6months", endDate >= minEndDate);
        	}
        	console.log($scope.editForm);
        }

    }
})();
